<template>
	<div id="SubscriptionInvoices" class="subscriptionInvoices">
		<div class="alert alert-warning" role="alert" v-if="countLegalDocumentsWithoutMigrateGenesys > 0 && needGenesys">
			Hay {{ countLegalDocumentsWithoutMigrateGenesys }} documento(s) legale(s) sin migrar
		</div>

        <nav class="navbar navbar-light bg-light">
			<div class="form-inline">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateFromLegalDocuments">
				<input class="form-control form-control-sm mr-sm-1" type="date" v-model="dateToLegalDocuments">
				<button class="btn btn-sm btn-outline-info my-2 my-sm-1" type="submit" @click="getLegalDocumentSubscriptionLocal(1)">Buscar</button>
			</div>
			<div class="form-inline">
				{{ listLegalDocumentsSubscriptionFilter.length }} registro(s)
			</div>
		</nav>

		<div class="table-responsive">
			<table class="table table-sm table-12 table-striped table-hover">
				<thead>
					<tr>
						<th class="text-center pointer" @click="setOrderByLegalDocuments('legal_documents.date_legal_document')">
							Fecha
							<span class="" v-if="(orderByLegalDocuments == 'legal_documents.date_legal_document')">
								<i :class="(orderByTypeLegalDocuments == 'asc') ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up'"></i>
							</span>
						</th>
						<th>Tipo de Documento</th>
						<th class="text-center pointer" @click="setOrderByLegalDocuments('legal_documents.legal_document_number')">
							Folio
							<span class="" v-if="(orderByLegalDocuments == 'legal_documents.legal_document_number')">
								<i :class="(orderByTypeLegalDocuments == 'asc') ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up'"></i>
							</span>
						</th>
						<th class="text-center">Monto</th>
						<th class="text-right" v-for="(item, index) in listTypePaymentsFilter" :key="index" v-if="item.vibility == 1">{{ item.name }}</th>
						<th class="text-center">Total</th>
						<th class="text-center">Suscripción</th>
						<th class="pointer" @click="setOrderByLegalDocuments('churchs.name')">
							Iglesia
							<span class="" v-if="(orderByLegalDocuments == 'churchs.name')">
								<i :class="(orderByTypeLegalDocuments == 'asc') ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up'"></i>
							</span>
						</th>
						<th>Cliente</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in listLegalDocumentsSubscriptionFilter" :key="index" :class="(orderIdSelected == item.order_id || churchIdSelected == item.church_id) ? 'font-weight-bold' : ''">
						<td class="text-center" @click="setDefaultSelection()">{{ item.date_legal_document }}</td>
						<td @click="setDefaultSelection()">{{ item.type_legal_document_name }}</td>						
						<td class="text-right" @click="setDefaultSelection()" :title="item.id">{{ item.legal_document_number }}</td>						
						<td class="text-right" @click="setDefaultSelection()">{{ methodFormatNumber(item.total) }}</td>
						<td class="text-right" v-for="(ite, index) in listTypePaymentsFilter" :key="index" v-if="ite.vibility == 1" @click="setDefaultSelection()">{{ methodFormatNumber(amountOrderPayment(ite.id, item)) }}</td>					
						<td class="text-right pointer" @click="orderIdSelected = item.order_id" title="Total">{{ methodFormatNumber(amountOrderPayment(-1, item)) }}</td>
						<td class="text-center" @click="setDefaultSelection()"><router-link :to="'/subscription/' + item.order_id" target="_blank" :title="'Subcripción ' + item.order_id">{{ item.order_id }}</router-link></td>						
						<td class="pointer" @click="churchIdSelected = item.church_id">{{ item.church }}</td>						
						<td @click="setDefaultSelection()">{{ item.client }}</td>
						<th class="text-right">
							<i class="fas fa-exchange-alt pointer" :title="'Migrar a Genesys'" v-if="needGenesys && item.legalDocumentGenesys == null && !migratingOrderToGenesys" @click="migrateToGenesysLocal(item)"></i>
							<div class="spinner-border spinner-border-sm" role="status" v-if="needGenesys && item.legalDocumentGenesys == null && migratingOrderToGenesys">
								<span class="sr-only">Loading...</span>
							</div>
						</th>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import typePayment from '@/mixins/generals/typePayment.js'
import order from '@/mixins/orders'
import legalDocument from '@/mixins/legalDocuments'

export default {
	name: 'SubscriptionInvoices',
	mixins: [axiosAction, errors, mixin, typePayment, order, legalDocument],
	props: ['year'],
	data() {
		return {
			dateFromLegalDocuments: '',
			dateToLegalDocuments: '',
			listLegalDocumentsSubscription: [],
			orderIdSelected: 0,
			churchIdSelected: 0,
			objectMigrate: [],
			migratingOrderToGenesys: false,
			orderByLegalDocuments: 'legal_documents.legal_document_number',
			orderByTypeLegalDocuments: 'asc'
		}
	},
	computed: {
		countLegalDocumentsWithoutMigrateGenesys() {
			let list = []
			list = this.listLegalDocumentsSubscriptionFilter.filter(e => {
						return (e.legalDocumentGenesys == null)
					})
			return list.length
		},
		listLegalDocumentsSubscriptionFilter () {
			let list = []
			this.listLegalDocumentsSubscription.forEach(legalDocument => {
				let index = list.map(e => parseInt(e.order_id)).indexOf(parseInt(legalDocument.order_id))
				if(index == -1) {
					legalDocument['showPayment'] = 1
				}
				list.push(legalDocument)
			})
			return list
		},
		listTypePaymentsFilter () {
			let list = []
			this.listLegalDocumentsSubscriptionFilter.forEach(legalDocument => {
				legalDocument.orderPayments.forEach(payment => {
					let index = this.listTypePayments.map(tp => parseInt(tp.id)).indexOf(parseInt(payment.type_payment_id))
					if(index > -1) {
						this.listTypePayments[index]['vibility'] = 1
					}
				})
			});
			list = this.listTypePayments
			return list
		}
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Documentos Legales Suscripción ' + this.year)
			this.setSubTitleModule('')
			this.getAllInitData()
		},
		amountOrderPayment(typePaymentId, ld) {
			let total = 0
			if(ld.showPayment == 1) {
				total = ld.orderPayments.reduce(function(a, b) {
						let c = 0
						if(b.type_payment_id == typePaymentId || -1 == typePaymentId) {
							c = b.amount
						}
						return a + c
					}, 0);
			}
			return total
		},
		getAllInitData() {
			this.dateFromLegalDocuments = this.currentDate(-7)
			this.dateToLegalDocuments = this.currentDate()
			this.reportGenesys('subscription')
			this.getAllTypePaymentsLocal()
			this.getLegalDocumentSubscriptionLocal()
		},
		getAllTypePaymentsLocal() {
			this.getAllTypePayments()
		},
		getAllTypePaymentsResultLocal(response) { },
		getLegalDocumentSubscriptionLocal() {
			this.listLegalDocumentsSubscription = []
			this.orderIdSelected = 0
			this.churchIdSelected = 0
			this.objectMigrate = []
			this.migratingOrderToGenesys = false
            this.$emit('showLockScreen', 'Buscando Documento Electronico . . .')
			let param = '?fromDate=' + this.dateFromLegalDocuments
			param += '&toDate=' + this.dateToLegalDocuments
			param += '&orderBy=' + this.orderByLegalDocuments
			param += '&orderByType=' + this.orderByTypeLegalDocuments
            let url = this.getApiBackend + 'legalDocuments/subscription/' + this.year + param
            this.axiosActionIS(url, 'GET', 'getLegalDocumentSubscriptionResult')
		},
		getLegalDocumentSubscriptionResult(response) {
			this.getLegalDocumentSubscriptionLocalResult(response)
		},
		getLegalDocumentSubscriptionLocalResult(response) {
			if(response.data.success == true) {
				this.listLegalDocumentsSubscription = response.data.data
			}
		},
		migrateToGenesysLocal(legalDocument) {
			if(!this.migratingOrderToGenesys) {
				this.objectMigrate = []
				if(legalDocument.order_id != null) {
					if(legalDocument.orderGenesys == null) {
						this.objectMigrate.push({type: 'order', id: legalDocument.order_id, ready: false})
					}
					if(legalDocument.legalDocumentGenesys == null) {
						this.objectMigrate.push({type: 'legalDocument', id: legalDocument.id, ready: false})
					}
					this.listLegalDocumentsSubscriptionFilter.forEach(ld => {
						if(ld.order_id == legalDocument.order_id && ld.id != legalDocument.id && ld.legalDocumentGenesys == null) {
							this.objectMigrate.push({type: 'legalDocument', id: ld.id, ready: false})
						}
					})
					this.runMigrateGenesysLocal()
				} else {
					alert('El Documento Legal debe estar vinculado con una Suscripción')
				}
			} else {
				console.log('Ya se está ejecutando el proceso de migración, espere un momento')
			}
		},
		migrateLegalDocumentToGenesysResultLocal(response) {
			if(response.data.success == true) {
				this.objectMigrate.forEach(e => {
					if(e.type == 'legalDocument' && parseInt(e.id) == parseInt(response.data.data.legal_document_id)) {
						e.ready = true
					}
				})
				let index = this.listLegalDocumentsSubscription.map(e => parseInt(e.id)).indexOf(parseInt(response.data.data.legal_document_id))
				if(index > -1) {
					this.listLegalDocumentsSubscription[index].legalDocumentGenesys = response.data.data
				}
				this.runMigrateGenesysLocal()
			} else {
				this.migratingOrderToGenesys = false
				alert(response.data.message)
			}
		},
		migrateOrderToGenesysResultLocal(response) {
			if(response.data.success == true) {
				this.objectMigrate.forEach(e => {
					if(e.type == 'order' && parseInt(e.id) == parseInt(response.data.data.order_id)) {
						e.ready = true
					}
				})
				this.listLegalDocumentsSubscription.forEach(ld => {
					if(parseInt(ld.order_id) == parseInt(response.data.data.order_id)) {
						ld.orderGenesys = response.data.data
					}
				})
				this.runMigrateGenesysLocal()
			} else {
				this.migratingOrderToGenesys = false
				alert(response.data.message)
			}
		},
		runMigrateGenesysLocal(){
			this.migratingOrderToGenesys = false
			for(let i=0; i < this.objectMigrate.length; i++) {
				if(this.objectMigrate[i].ready == false) {
					this.migratingOrderToGenesys = true
					if(this.objectMigrate[i].type == 'order') {
						this.migrateOrderToGenesys(this.objectMigrate[i].id, 'subscription')
					} else if (this.objectMigrate[i].type == 'legalDocument') {
						this.migrateLegalDocumentToGenesys(this.objectMigrate[i].id)
	
					}
					i = this.objectMigrate.length
				}
			}
		},
		reportGenesysResultLocal(response) {},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'getAllTypePaymentsResult': this.getAllTypePaymentsResult(response); break;
				case 'getLegalDocumentSubscriptionResult': this.getLegalDocumentSubscriptionResult(response); break;
				case 'migrateLegalDocumentToGenesysResult': this.migrateLegalDocumentToGenesysResult(response); break;
				case 'migrateOrderToGenesysResult': this.migrateOrderToGenesysResult(response); break;
				case 'reportGenesysResult': this.reportGenesysResult(response); break;
		        default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
		setOrderByLegalDocuments(orderBy) {
			if(orderBy != this.orderByLegalDocuments) {
				this.orderByLegalDocuments = orderBy
				this.orderByTypeLegalDocuments = 'asc'
			} else {
				this.orderByTypeLegalDocuments = (this.orderByTypeLegalDocuments == 'asc') ? 'desc' : 'asc'
			}
			this.getLegalDocumentSubscriptionLocal(1)
		},
		setDefaultSelection() {
			this.orderIdSelected = 0
			this.churchIdSelected = 0
		},
		setOrderByLegalDocuments(orderBy) {
			if(orderBy != this.orderByLegalDocuments) {
				this.orderByLegalDocuments = orderBy
				this.orderByTypeLegalDocuments = 'asc'
			} else {
				this.orderByTypeLegalDocuments = (this.orderByTypeLegalDocuments == 'asc') ? 'desc' : 'asc'
			}
			this.getLegalDocumentSubscriptionLocal(1)
		},
	},
	components: {
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
</style>